import Vue from 'vue';

const state = {
  libraryTaggings: [],
  tags: {},
};

const getters = {
  all: (state) => Object.keys(state.tags).map(tid => state.tags[tid]),
  get: (state) => state.tags,
  libraryTaggings: (state) => state.libraryTaggings,
};

const mutations = {
  set: (state, tags) => {
    tags.forEach(tag => {
      Vue.set(state.tags, tag.id, tag);
    });
  },
  setLibraryTaggings: (state, taggings) => {
    state.libraryTaggings = taggings;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
